const swea = require('swea');
import * as globals from '../globals';
const TextureLabelEyeDropperInteraction = swea.editor.interactions.TextureLabelEyeDropperInteraction;
const ContextMenuStateServiceActions = swea.react.actions.ContextMenuStateServiceActions;
const ContextMenuStateService = swea.react.services.ContextMenuStateService;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const TextureLabelService = swea.react.services.TextureLabelService;
const ViewerManager = swea.editor.ViewerManager;


class CustomTextureLabelEyeDropperInteraction extends TextureLabelEyeDropperInteraction {
  /**
   * Constructs the interaction.
   * @param { object } options An option object, see below and {@link TextureLabelEyeDropperInteraction} for more info.
   * @param { function } options.callback (optional) A callback function to call instead of showing images, taking the result from TextureLabelAdapter._collectLabelImages as argument.
   * @param { boolean } options.imageSelectionInteraction The image selection interaction.
   * @public
   */  
  constructor(options = {}) {
    super(options);
    this._callback = options.callback;
    this._imageSelectionInteraction = options.imageSelectionInteraction;
    
    if (this._imageSelectionInteraction !== undefined) {
      // Remember if image catalog should be reopened or not for other image view functionality than this
      this._reopen = this._imageSelectionInteraction.getReopen();
    }
  }
  
  /**
   * Starts listening to image viewer. Overriden to disable reopening image catalog as well.
   * @public
   * @override
   */
  startListening() {
    super.startListening();
    if (this._imageSelectionInteraction !== undefined) {
      this._imageSelectionInteraction.setReopen(false);
    }
  }
  
  /**
   * Stops listening to image viewer. Overridden to possibly enable reopening image catalog as well.
   * @public
   * @override
   */
  stopListening() {
    super.stopListening();
    if (this._imageSelectionInteraction !== undefined) {
      this._imageSelectionInteraction.setReopen(this._reopen);
    }
  }
  
  /**
   * Called before picking to set wait cursor
   * @private
   */
  _beforePick() {
    ViewerManager.instance().getViewerById(this._viewerId).setCursor('wait');
 
    if (this._imageSelectionInteraction !== undefined) {
      // Inactivate any reopening
      this._imageSelectionInteraction.setReopen(false);
    }
  }
  
  /**
   * Called when a pixel containing labels has been picked, collecting label images.
   * Hides instruction and sets default cursor.
   * @param { object[] } labels An array of label objects, see TextureLabelAdapter for a description.
   * @private
   * @override
   */
  _whenPicked(labels) {
    ViewerManager.instance().getViewerById(this._viewerId).setCursor('default');
    if (this._callback !== undefined) {
      this._callback(this._collectLabelImages(labels));
      this._whenClosed();
    }
    else {
      super._whenPicked(labels);
    }
    
    if (labels.length > 0) {
      ContextMenuStateServiceActions.openContextMenu(
        globals.LOWER_CONTEXT_MENU,
        globals.TEXTURE_LABEL_EYE_DROPPER_ACTIVATED
      );
    }
    else if (ContextMenuStateService.instance().getCurrentMenuContext(globals.LOWER_CONTEXT_MENU) === globals.TEXTURE_LABEL_EYE_DROPPER_ACTIVATED) {
      ContextMenuStateServiceActions.closeContextMenu(
        globals.LOWER_CONTEXT_MENU
      );
    }
  }
  
  /**
   * Called when hulls have been calculated for the current image, regardless of if they are visualized or not.
   * @private
   * @override
   */
  _gotHulls() {
    if (TextureLabelService.instance().getState().crop) {
      if (this._filteredHulls.length < this._hulls.length || this._hulls.length === 0) {
        InstructionServiceActions.showInstruction('components.texturelabeleyedropper.smallhulls');
      }
      else {
        InstructionServiceActions.hideInstruction();
      }
    }
  }
}
export default CustomTextureLabelEyeDropperInteraction;
